import { render, staticRenderFns } from "./MlbFullStats.vue?vue&type=template&id=424774d9&scoped=true"
import script from "./MlbFullStats.vue?vue&type=script&lang=js"
export * from "./MlbFullStats.vue?vue&type=script&lang=js"
import style0 from "./MlbFullStats.vue?vue&type=style&index=0&id=424774d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424774d9",
  null
  
)

export default component.exports